// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__pE7Y_","addWidgetButton":"Header_addWidgetButton__3WGoM","dashboardTabs":"Header_dashboardTabs__3KEuf","active":"Header_active__2FjR5"};